import { render, staticRenderFns } from "./RHBSmartForm.vue?vue&type=template&id=0b672773"
import script from "./RHBSmartForm.vue?vue&type=script&lang=js"
export * from "./RHBSmartForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports